import React, { useEffect, useRef } from "react";

import '../../assets/styles/SlidersGroupQuestion.css';

const SlidersGroupQuestion = ({ question, groupItems, onChange, answers = {} }) => {
    // console.log('groupItems', groupItems);
    
    const rangeRefs = useRef({});

    const getThumbColor = (percent, symFor) => {
        if (symFor === 2) {
            // console.log("A", percent);
            if (percent < 40) return "#446D41";
            if (percent < 80) return "#F0B214";
            return "#F02E14";
        } else {
            // console.log("B", percent);
            if (percent < 10) return "#666666";
            if (percent < 40) return "#F02E14";
            if (percent < 80) return "#F0B214";
            return "#446D41";
        }
    };
    
    useEffect(() => {
        groupItems.forEach((item) => {
            const slider = rangeRefs.current[item.sym_id];
            if (!slider) return;

            const min = 0;
            const max = item.step_quantity || 10;
            
            const value = answers[item.sym_id]?.answer ?? min;

            const safeValue = Math.round(((value ?? 0) / 10) * max);

            const percent = (safeValue > 0) ? ((safeValue - min) / (max - min)) * 100 : 0;
            const adjusted = percent < 80 ? percent : percent / 2;

            const thumbColor = getThumbColor((safeValue === 0) ? 0 : percent, question.sym_for);

            slider.style.setProperty("--progress", `${adjusted}%`);
            slider.style.setProperty("--progress2", `${percent}%`);
            slider.style.setProperty("--thumb-color", thumbColor);
        });
    }, [answers, groupItems]);

    return (
        <div className="sliders-group question py-4 py-lg-5">

            {groupItems.map((item) => {
                const value = answers[item.sym_id]?.answer ?? 0;
                const min = 0;
                const max = item.step_quantity ?? 10;
                const safeValue = Math.round(((value ?? 0) / 10) * max);
                const type = item.sym_for === 1 ? "-var" : "";

                return (
                    <div key={item.sym_id} className="slider-item mb-4">

                        <div className="row justify-content-between">
                            
                            {item.icon && (
                                <div className="col-auto">
                                    <img src={`${process.env.PUBLIC_URL}/assets/images/svg/${item.icon}`} alt={item.label} />
                                </div>
                            )}
                            
                            <div className="col">

                                <div className="sliders-group-header mb-2">
                                    <h4 className="mb-2 opensans"><strong style={{fontWeight: "700"}}>{item.label}</strong></h4>
                                    {item.sublabel && <p>{item.sublabel}</p>}
                                </div>
                                {
                                    item.type === "text+range" ? (
                                        <>
                                        <input
                                            type="text"
                                            className="form-control mb-2"
                                            value={answers[item.sym_id]?.extra || ""}
                                            onChange={(e) => onChange(item.sym_id, {
                                                ...answers[item.sym_id],
                                                extra: e.target.value,
                                                answer: answers[item.sym_id]?.answer ?? 0
                                            }, item)}
                                            placeholder={item.placeholder || "Especifique"}
                                        />
                                        <input
                                            type="range"
                                            ref={(el) => (rangeRefs.current[item.sym_id] = el)}
                                            className={`form-range${type}`}
                                            min={min}
                                            max={max}
                                            value={safeValue}
                                            onChange={(e) => {
                                                const raw = Number(e.target.value);
                                                const normalized = Math.round((raw / max) * 10);
                                                onChange(item.sym_id, {
                                                    ...answers[item.sym_id],
                                                    answer: normalized,
                                                    extra: answers[item.sym_id]?.extra || ""
                                                }, item)
                                            }}
                                        />

                                        </>
                                    ) : (
                                        <input
                                            type="range"
                                            className={`form-range${type}`}
                                            min={min}
                                            max={max}
                                            ref={(el) => (rangeRefs.current[item.sym_id] = el)}
                                            value={safeValue}
                                            onChange={(e) => {
                                                const raw = Number(e.target.value);
                                                const normalized = Math.round((raw / max) * 10);
                                                onChange(item.sym_id, normalized, item)
                                                
                                            }}
                                        />
                                    )
                                }
                                
                                <div className="container">
                                    <div className="range-labels row justify-content-between">
                                        {[...Array((item.step_quantity || 10) - (item.type === "text+range" ? 0 : 0) + 1).keys()].map((i) => (
                                            <span key={i} className="col-auto px-0">
                                                {i + (item.type === "text+range" ? 0 : 0)}
                                            </span>
                                        ))}
                                    </div>
                                </div>
                            </div>
                        </div>
                        
                    </div>
                );
            })}
        </div>
    );
};

export default SlidersGroupQuestion;